import React from 'react';
import PropTypes from 'prop-types';

export const TD = ({ className = null, children }) => (
  <td className={className}>
    <div>{children}</div>
  </td>
);

TD.propTypes = {
  className: PropTypes.node,
  children: PropTypes.node.isRequired,
};

export const TH = ({ className = null, children }) => (
  <th className={className}>
    <div>{children}</div>
  </th>
);

TH.propTypes = {
  className: PropTypes.node,
  children: PropTypes.node.isRequired,
};
